module.exports = __webpack_public_path__ + "media/access/one-f5a2b680.png";